module.exports = __webpack_public_path__ + "static/contact-header-big.a18782f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact-header-big.jpg
// module id = 435
// module chunks = 70144966829960